import {
  isPatrolmanPlusSku,
  isPatrolmanSku,
  isReconSku,
} from "../configuration-sku-family.js";

/** Year labels stocked at Pre-Encapsulation (station 13) via manufacturing.station_stock. */
export const PRE_ENCAP_YEAR_LABEL_SKUS = {
  FI_3C: "88-014-CY",
  FI_5A: "88-105-CY",
} as const;

const PRE_ENCAP_YEAR_LABEL_SKU_SET_LOWER = new Set(
  Object.values(PRE_ENCAP_YEAR_LABEL_SKUS).map((sku) => sku.toLowerCase()),
);

export function isPreEncapYearLabelStationStockSku(skuRaw: string): boolean {
  const sku = skuRaw.trim().toLowerCase();
  return PRE_ENCAP_YEAR_LABEL_SKU_SET_LOWER.has(sku);
}

/** Map a finished device SKU to the year label consumed at pre-encapsulation scan. */
export function resolvePreEncapYearLabelSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isReconSku(finishedSku)) return PRE_ENCAP_YEAR_LABEL_SKUS.FI_3C;
  if (isPatrolmanSku(finishedSku) || isPatrolmanPlusSku(finishedSku)) {
    return PRE_ENCAP_YEAR_LABEL_SKUS.FI_5A;
  }
  return null;
}
